<template>
  <v-dialog
    class="standard-size"
    content-class="dialog-product--modal"
    persistent
    scrollable
    width="97vw"
    v-model="dialog"
    ref="dialog_product"
  >
    <v-card class="dialog-product--modal-card">
      <ValidationObserver v-slot="{ handleSubmit }" ref="form">
        <form @submit.prevent="handleSubmit(submit)">
          <get-body-email
            app_label="sales"
            model="orderproduct"
            :condition="
              subOrder.status !== oldStatus && subOrder.status !== null
            "
            :customerNotification="subOrder.clientNotification"
            :stateMain="subOrder.orderMain"
            :stateID="subOrder.status"
            :template="subOrder.template"
            :subject="
              $t('orderupdate', {
                product: subOrder.own_prod,
                old: oldStatusName,
                new: subOrder.orderStatus
              })
            "
            :recipient_list="subOrder.clientEmail"
            ref="getbodyemail"
          />
          <i-toolbar
            dark
            color="secondary"
            dontSave
            :title="`${subOrder.own_prod}`"
            :loading="loading"
          >
            <template v-slot:close>
              <i-btn
                text
                icon="fa-times"
                :loading="load"
                :small="$vuetify.breakpoint.smAndDown"
                :title="$t('close')"
                @click="close()"
              >
              </i-btn>
            </template>
            <template v-slot:arrowLeft>
              <v-divider class="mx-4" inset vertical></v-divider>
              <div style="display: block; min-width: 64px">
                <i-btn
                  v-if="step > 1 && creatingDetail === 1"
                  color="text-dark"
                  icon="fa-arrow-left"
                  text
                  :small="$vuetify.breakpoint.smAndDown"
                  :title="$t('back')"
                  @click="back()"
                >
                </i-btn>
              </div>
            </template>
            <template v-slot:arrowRight>
              <div style="display: block; min-width: 64px">
                <i-btn
                  v-if="showNext()"
                  color="text-dark"
                  icon="fa-arrow-right"
                  text
                  :small="$vuetify.breakpoint.smAndDown"
                  :title="$t('next')"
                  @click="next()"
                >
                </i-btn>
              </div>
            </template>
            <template v-slot:submit>
              <i-btn
                v-if="creatingDetail === 1"
                icon="fa-save"
                text
                :small="$vuetify.breakpoint.smAndDown"
                :title="$tc('save', 1)"
                @click="submit()"
              >
              </i-btn>
            </template>
          </i-toolbar>
          <v-card-text class="px-0">
            <v-container fluid>
              <v-stepper style="z-index: 0" class="elevation-0" v-model="step">
                <!-- Lista de pasos -->
                <v-stepper-header class="elevation-0">
                  <v-stepper-step :step="1" edit-icon="$complete" editable>
                    {{ $t('basic') }}
                  </v-stepper-step>
                  <v-divider v-show="subOrder.pk"></v-divider>
                  <v-stepper-step
                    v-show="checkPermissions.details && subOrder.pk"
                    edit-icon="$complete"
                    :step="2"
                    :editable="subOrder.pk !== ''"
                  >
                    {{ $tc('price_calculation', 2) }}
                  </v-stepper-step>
                </v-stepper-header>
                <v-stepper-items>
                  <!-- Paso 1 -->
                  <v-stepper-content :step="1">
                    <v-row class="my-0">
                      <!-- Imagen -->
                      <v-col cols="12" md="3">
                        <v-skeleton-loader
                          v-if="loading || loadingIMG"
                          type="image"
                          tile
                        ></v-skeleton-loader>
                        <i-image
                          v-else
                          class="image-repo"
                          :readonly="
                            subOrder.orderMain == 'canceled' ||
                            subOrder.orderMain == 'finished'
                          "
                          :file.sync="subOrder.thumbnail"
                          v-model="imageUrl"
                        />
                      </v-col>

                      <!-- Demás datos -->
                      <v-col cols="12" md="9">
                        <set-suborder-state
                          v-if="
                            subOrder.template &&
                            stages.length > 0 &&
                            (canChangeStatus.inDesign ||
                              canChangeStatus.underReview)
                          "
                          :states="stages"
                          @submitAndClose="submit()"
                          @confirmDesigner="confirmDesigner()"
                          v-model="subOrder.status"
                        />
                        <v-row class="mt-0 mb-5">
                          <!-- Código de la suborden -->
                          <v-col
                            v-if="subOrder.code && subOrder.code !== ''"
                            cols="12"
                            sm="6"
                            md="4"
                          >
                            <v-skeleton-loader
                              v-if="loading"
                              type="text"
                              tile
                            ></v-skeleton-loader>
                            <v-text-field
                              v-else
                              color="secondary"
                              disabled
                              key="code-input"
                              outlined
                              :label="$tc('code', 1)"
                              v-model="subOrder.code"
                            >
                            </v-text-field>
                          </v-col>

                          <!-- Nombre de la suborden -->
                          <v-col
                            v-if="subOrder !== undefined && subOrder !== null"
                            cols="12"
                            sm="6"
                            md="4"
                          >
                            <v-skeleton-loader
                              v-if="loading"
                              type="text"
                              tile
                            ></v-skeleton-loader>
                            <ValidationProvider
                              vid="name"
                              :name="$tc('name', 1)"
                              :rules="{ required: step == 1 }"
                              v-slot="{ errors }"
                            >
                              <v-text-field
                                v-show="!loading"
                                color="secondary"
                                key="name-input"
                                outlined
                                :disabled="checkPhase.isReadOnly"
                                :error-messages="errors[0]"
                                :label="$tc('subname', 1)"
                                v-model="subOrder.name"
                              >
                                <div
                                  v-if="
                                    projectName &&
                                    subOrder.orderMain === 'draft'
                                  "
                                  slot="prepend"
                                >
                                  <v-icon
                                    color="primary"
                                    medium
                                    v-text="'fa-clone'"
                                    @click="cloneNameProject()"
                                  />
                                </div>
                              </v-text-field>
                            </ValidationProvider>
                          </v-col>

                          <!-- Nombre del cliente -->
                          <v-col
                            v-show="checkPermissions.customer"
                            cols="12"
                            sm="6"
                            md="4"
                          >
                            <v-skeleton-loader
                              v-if="loading"
                              type="text"
                              tile
                            ></v-skeleton-loader>
                            <v-text-field
                              v-show="!loading"
                              color="secondary"
                              outlined
                              disabled
                              :value="defineClientInfo"
                              :label="$tc('customer', 1)"
                            >
                            </v-text-field>
                          </v-col>
                        </v-row>
                        <div class="container-buttons">
                          <!-- Botón de Descripción -->
                          <v-btn
                            @click="activate(1)"
                            :color="
                              divDescription
                                ? 'secondary'
                                : subOrder.description != ''
                                ? 'success'
                                : ''
                            "
                          >
                            {{ $tc('description', 1) }}
                          </v-btn>

                          <!-- Botón de Información adicional -->
                          <v-btn
                            @click="activate(2)"
                            :color="
                              divAditionalSide
                                ? 'secondary'
                                : subOrder.additional_side != ''
                                ? 'success'
                                : ''
                            "
                          >
                            {{ $tc('additional_side', 1) }}
                          </v-btn>

                          <!-- Botón de Repositorio -->
                          <v-btn
                            v-if="
                              subOrder.pk && checkPermissions.imageRepository
                            "
                            :color="divRepository ? 'secondary' : ''"
                            @click="activate(3)"
                          >
                            {{ $tc('repository', 1) }}
                          </v-btn>

                          <!-- Botón de Logs -->
                          <v-btn
                            v-if="
                              subOrder.pk && checkPermissions.isElevatedRole
                            "
                            :color="divLogs ? 'secondary' : ''"
                            @click="activate(5)"
                          >
                            Logs
                          </v-btn>

                          <!-- Botón de Fechas -->
                          <v-btn
                            v-if="
                              subOrder.pk !== '' && checkPermissions.typedate
                            "
                            :color="divDates ? 'secondary' : ''"
                            @click="activate(6)"
                          >
                            {{ $tc('dates', 1) }}
                          </v-btn>

                          <!-- Botón de Notas/Chat -->
                          <div
                            v-if="
                              subOrder.orderMain === 'in_process' ||
                              subOrder.orderMain === 'in_production' ||
                              subOrder.orderMain === 'production_ready' ||
                              subOrder.orderMain === 'delivery' ||
                              subOrder.orderMain === 'finished' ||
                              subOrder.orderMain === 'correction' ||
                              subOrder.orderMain === 'canceled'
                            "
                          >
                            <v-btn
                              v-if="subOrder.pk !== ''"
                              :color="divNotes ? 'secondary' : ''"
                              :class="hasChatMessages ? 'has-messages' : ''"
                              @click="activate(4)"
                            >
                              {{ $tc('notes_chat', 1) }}
                            </v-btn>
                          </div>
                        </div>
                      </v-col>
                      <v-col cols="12">
                        <!-- Descripción -->
                        <div v-show="divDescription">
                          <v-skeleton-loader
                            v-if="loading"
                            type="article"
                            tile
                          ></v-skeleton-loader>
                          <vue-editor
                            v-if="!loading"
                            :disabled="checkPhase.isInFinalPhase"
                            :editorToolbar="customToolbar"
                            :placeholder="$t('description')"
                            :readonly="checkPhase.isInFinalPhase"
                            v-model="subOrder.description"
                          >
                          </vue-editor>
                        </div>
                        <!-- Información adicional -->
                        <div v-show="divAditionalSide">
                          <v-skeleton-loader
                            v-if="loading"
                            type="article"
                            tile
                          ></v-skeleton-loader>
                          <vue-editor
                            v-if="!loading"
                            :disabled="checkPhase.isInFinalPhase"
                            :editorToolbar="customToolbar"
                            :placeholder="$t('additional_side')"
                            :readonly="checkPhase.isInFinalPhase"
                            v-model="subOrder.additional_side"
                          >
                          </vue-editor>
                        </div>
                        <!-- Repositorio -->
                        <div v-show="divRepository">
                          <repository
                            v-if="
                              subOrder.pk !== '' &&
                              checkPermissions.imageRepository
                            "
                            :subOrderPk="subOrder.pk"
                          />
                        </div>
                        <!-- Notas/Chat -->
                        <div ref="scrollTarget" v-show="divNotes">
                          <order-messages
                            ref="orderMessagesComponent"
                            :chat_id="subOrder.chat_id"
                            @file-picked="scrollToBottom"
                          />
                        </div>
                        <!-- Logs -->
                        <div v-show="divLogs">
                          <div
                            v-for="(value, key) in logs"
                            :key="key"
                            class="border rounded mb-2 py-2 px-3"
                          >
                            <p class="mb-1">
                              <span class="font-weight-bold">
                                {{ $tc('suborder', 1) }}:
                              </span>
                              {{
                                $tc(answerList[value.action]) ||
                                $tc(answerList[4])
                              }}
                            </p>
                            <p class="mb-1">
                              <span class="font-weight-bold">
                                {{ $tc('date') }}:
                              </span>
                              {{ value.date }}
                            </p>
                            <p class="mb-1">
                              <span class="font-weight-bold">
                                {{ $tc('time') }}:
                              </span>
                              {{ value.time }}
                            </p>
                            <p class="mb-1 font-weight-bold">
                              {{ $tc('action') }}:
                            </p>
                            <ul>
                              <li
                                v-for="(item, attr) in value.changes"
                                :key="attr"
                              >
                                {{ attr }}: {{ item[0] }}
                                <span
                                  class="font-weight-bold"
                                  style="color: var(--success)"
                                >
                                  ->
                                </span>
                                {{ item[1] }}
                              </li>
                            </ul>
                            <p class="mb-1">
                              <span class="font-weight-bold">Usuario:</span>
                              {{ value.fullname }}
                            </p>
                          </div>
                        </div>
                        <!-- Fechas -->
                        <div v-show="divDates">
                          <type-date
                            v-if="
                              checkPermissions.typedate &&
                              subOrder.pk !== '' &&
                              product !== null
                            "
                            :order="subOrder.pk"
                            :template="subOrder.template"
                          />
                        </div>
                      </v-col>
                    </v-row>
                  </v-stepper-content>

                  <!-- Paso 2 -->
                  <v-stepper-content
                    v-if="subOrder.pk"
                    class="dialog-product--modal-second-step"
                    :step="2"
                  >
                    <!-- Tipo de precio matriz -->
                    <v-row v-if="subOrder.price_type === 'matrix'" class="my-0">
                      <v-col class="pt-0" cols="12">
                        <i-matrix
                          :hideSubtotal="!checkPermissions.isElevatedRole"
                          :type_customer="subOrder.level"
                          :productId="subOrder.product"
                          :priceString="subOrder.priceString"
                          :price="subOrder.price"
                          :qty="subOrder.quantity"
                          :subOrder.sync="subOrder"
                          :matrixUse="'details'"
                          :canViewPrice="checkPermissions.isElevatedRole"
                          :canViewCost="
                            checkPermissions.isElevatedRole && showCost
                          "
                          @change="subOrder.price = $event"
                        >
                        </i-matrix>
                      </v-col>
                    </v-row>

                    <!-- Los demás tipos de precio (Base y Fórmula) -->
                    <v-row v-else class="my-0">
                      <!-- El aviso del f2 -->
                      <v-col
                        v-if="checkPermissions.isElevatedRole"
                        class="pt-0"
                        cols="12"
                      >
                        <p class="font-weight-bold body-2">
                          <span v-show="!showCost">{{ $t('f2key') }}</span>
                          <i-money
                            v-show="showCost"
                            class="font-weight-black primary--text"
                            mode="text"
                            :value="subOrder.costprod"
                            :label="`${$tc('cost', 1)} = `"
                          />
                        </p>
                      </v-col>

                      <!-- switch redondeo -->
                      <v-col v-if="measure" cols="12">
                        <v-skeleton-loader
                          v-if="
                            loading &&
                            measure !== undefined &&
                            measure !== null &&
                            measure.rounded
                          "
                          type="list-item-avatar"
                          tile
                        ></v-skeleton-loader>
                        <v-switch
                          v-show="!loading"
                          class="v-switch mt-0"
                          color="primary"
                          key="rounded-input"
                          name="rounded"
                          :disabled="checkPhase.isReadOnly"
                          :label="$tc('rounded', 1)"
                          v-model="subOrder.rounded"
                        ></v-switch>
                      </v-col>

                      <!-- Select de fórmula de venta -->
                      <v-col
                        v-show="
                          checkPermissions.soldby &&
                          subOrder.price_type === 'formula'
                        "
                        cols="12"
                        sm="6"
                        lg="3"
                      >
                        <v-skeleton-loader
                          v-if="loading"
                          type="list-item-avatar"
                          tile
                        ></v-skeleton-loader>
                        <ValidationProvider
                          vid="measure"
                          :name="$tc('measure', 1)"
                          :rules="{ required: subOrder.pk !== '' && step == 2 }"
                          v-slot="{ errors }"
                        >
                          <v-select
                            v-show="!loading"
                            color="primary"
                            item-text="name"
                            item-value="pk"
                            outline
                            outlined
                            :disabled="
                              checkPhase.isReadOnly ||
                              !checkPermissions.soldbyEdit
                            "
                            :error-messages="errors[0]"
                            :items="measures"
                            :label="$tc('measure', 1)"
                            v-model="subOrder.measure"
                          ></v-select>
                        </ValidationProvider>
                      </v-col>

                      <!-- Cantidad -->
                      <v-col cols="12" sm="6" lg="3">
                        <ValidationProvider
                          v-if="step === 2"
                          vid="amount"
                          :name="$tc('amount', 1)"
                          :rules="{ required: true, min_value: 1 }"
                          v-slot="{ errors }"
                        >
                          <v-text-field
                            color="secondary"
                            outlined
                            :disabled="checkPhase.isReadOnly"
                            :error-messages="errors[0]"
                            :label="$tc('amount', 1)"
                            v-model="subOrder.quantity"
                          >
                            <template v-slot:append>
                              <v-icon
                                :disabled="checkPhase.isReadOnly"
                                @click="changeQuantity('+1')"
                              >
                                mdi-plus
                              </v-icon>
                              <v-icon
                                :disabled="
                                  parseFloat(subOrder.quantity) <= 1 ||
                                  checkPhase.isReadOnly
                                "
                                @click="changeQuantity('-1')"
                              >
                                mdi-minus
                              </v-icon>
                            </template>
                          </v-text-field>
                        </ValidationProvider>
                      </v-col>

                      <!-- Esto maneja el precio productos tipo base -->
                      <div v-show="false">
                        <show-product-price
                          :pkProduct="subOrder.product"
                          :priceSuggest="priceSuggest"
                          :type_customer="subOrder.level"
                          :customer="customer"
                          @change="subOrder.price = $event"
                        />
                      </div>

                      <!-- Precio si es base -->
                      <v-col
                        v-show="
                          subOrder.price_type === 'base' &&
                          checkPermissions.isElevatedRole
                        "
                        cols="12"
                        sm="6"
                        lg="3"
                      >
                        <v-alert outlined color="primary">
                          <i-money
                            mode="text"
                            :label="`${$t('sale_price')}:`"
                            v-model="subOrder.price"
                          />
                        </v-alert>
                      </v-col>

                      <!-- Subtotal si es base -->
                      <v-col
                        v-show="
                          subOrder.price_type === 'base' &&
                          checkPermissions.isElevatedRole
                        "
                        cols="12"
                        sm="6"
                        lg="3"
                      >
                        <v-alert type="info" outlined color="primary">
                          <i-money
                            mode="text"
                            :value="subOrder.price * subOrder.quantity"
                            :label="$t('subtotal')"
                          />
                        </v-alert>
                      </v-col>

                      <!-- Si es fórmula -->
                      <v-col v-if="measure" class="pt-0" cols="12">
                        <i-formula
                          v-show="subOrder.price_type === 'formula' && measure"
                          :readonly="checkPhase.isReadOnly"
                          :showResult="checkPermissions.isElevatedRole"
                          :canViewPrice="checkPermissions.isElevatedRole"
                          :dimensions="subOrder.dimensions"
                          :defaultMeasure="defaultmeasure"
                          :price="
                            Number(
                              subOrder.prodPrice === 0
                                ? priceSuggest
                                : subOrder.prodPrice
                            ) || 0
                          "
                          :cost="subOrder.costprod"
                          :measure="measure.name.split('(')[1].replace(')', '')"
                          :formula="measure.formula"
                          :rounded="
                            !(
                              measure !== undefined &&
                              measure !== null &&
                              measure.rounded
                            )
                              ? false
                              : subOrder.rounded
                          "
                          :qty="subOrder.quantity"
                          :subOrder="subOrder"
                          @change="subOrder.price = $event"
                          @changedimensions="subOrder.dimensions = $event"
                          v-model="subOrder.priceString"
                        />
                      </v-col>
                    </v-row>

                    <!-- Detalles de producción guardados en la suborden -->
                    <details-by-order
                      v-if="checkPermissions.isElevatedRole"
                      :creatingDetail.sync="creatingDetail"
                      :defaultMeasure="defaultmeasure"
                      :dimensions="subOrder.dimensions"
                      :canViewPrice="checkPermissions.isElevatedRole"
                      :canViewCost="checkPermissions.isElevatedRole && showCost"
                      :measure="
                        measure !== undefined && measure !== null
                          ? measure.name.split('(')[1].replace(')', '')
                          : ''
                      "
                      :order="subOrder.pk"
                      :qty="subOrder.quantity"
                      :readonly="checkPhase.isReadOnly"
                      :rounded="
                        !(
                          measure !== undefined &&
                          measure !== null &&
                          measure.rounded
                        )
                          ? false
                          : subOrder.rounded
                      "
                      :subOrder="subOrder"
                      :type_customer="subOrder.level"
                      ref="detailsForm"
                      v-model="detailPrices"
                    />
                  </v-stepper-content>
                </v-stepper-items>
              </v-stepper>
            </v-container>
          </v-card-text>
          <v-card-actions
            v-if="
              checkPermissions.isElevatedRole && product !== null && step === 2
            "
            class="dialog-product--fixed-actions"
          >
            <v-row class="my-0">
              <!-- Detalles de producción -->
              <v-col class="dialog-product--fixed-left" cols="12" md="8">
                <div class="dialog-product--fixed-details p-3">
                  <!-- Detalles de producción asociados a la venta -->
                  <p
                    v-if="detailPrices.length > 0"
                    class="mb-2 font-weight-bold"
                  >
                    {{ $t('details_production') }}
                  </p>
                  <p
                    v-for="(item, key) in detailPrices.filter(
                      (element) => element.hidden === false
                    )"
                    :key="`pricesExtra-${key}`"
                    class="details-selected-sumatory white--text mb-0"
                  >
                    <span>
                      &bull; {{ item.name }}
                      <template v-if="item.hidden">(hidden)</template>
                    </span>
                    <span class="dotted-span"></span>
                    <span>
                      <template v-if="item.is_multipliable">
                        ({{ item.price + 'x' + subOrder.quantity }}):
                      </template>
                      <i-money
                        mode="text"
                        :value="
                          itemMultiply(
                            item.is_multipliable,
                            item.price,
                            subOrder.quantity
                          )
                        "
                      />
                    </span>
                  </p>
                  <p
                    v-if="hiddenDetailsSum()"
                    class="details-selected-sumatory white--text mb-0"
                    key="pricesExtraHidden"
                  >
                    <span> &bull; {{ $t('hidden') }}</span>
                    <span class="dotted-span"></span>
                    <span>
                      <i-money mode="text" :value="hiddenDetailsSum()" />
                    </span>
                  </p>

                  <!-- Extra/Descuento -->
                  <v-col class="d-none py-2" col="12" md="4" lg="3">
                    <change-price
                      v-if="subOrder.pk"
                      :readonly="checkPhase.isReadOnly"
                      :price="subOrder.price"
                      :order="subOrder.pk"
                      @changeTotal="rewriteprice = $event"
                      @input="input = $event"
                      v-model="discount"
                    />
                  </v-col>
                </div>
              </v-col>

              <!-- Sumatorias -->
              <v-col class="dialog-product--fixed-right" cols="12" md="4">
                <div class="dialog-product--fixed-total">
                  <!-- Precio del producto -->
                  <p v-if="detailPrices.length > 0" class="text-sumatory mb-0">
                    <span>{{ $tc('product', 1) }}</span>
                    <span class="dotted-span"></span>
                    <i-money
                      class="main--text pl-1"
                      mode="text"
                      :value="subOrder.price * subOrder.quantity"
                    />
                  </p>

                  <!-- Detalles de producción -->
                  <p v-if="detailPrices.length > 0" class="text-sumatory mb-0">
                    <span>{{ $t('details_production') }}</span>
                    <span class="dotted-span"></span>
                    <i-money
                      class="main--text pl-1"
                      mode="text"
                      :value="detailsSum(detailPrices)"
                    />
                  </p>

                  <!-- Subtotal -->
                  <p class="text-sumatory mb-0">
                    <span>{{ $t('subtotal') }}</span>
                    <span class="dotted-span"></span>
                    <i-money
                      class="main--text pl-1"
                      mode="text"
                      :value="subtotal()"
                    />
                  </p>

                  <!-- Impuestos -->
                  <p class="text-sumatory mb-0">
                    <span>{{ $tc('tax', 1) }}</span>
                    <span class="dotted-span"></span>
                    <i-money
                      class="main--text"
                      mode="text"
                      :value="subOrder.tax"
                    />
                  </p>

                  <!-- Descuento -->
                  <p v-if="discount < 0" class="text-sumatory mb-0">
                    <span>{{ $t('title_discount') }}</span>
                    <span class="dotted-span"></span>
                    <i-money
                      class="main--text pl-1"
                      mode="text"
                      :value="discount"
                    />
                  </p>

                  <!-- Total -->
                  <p class="text-sumatory mb-0">
                    <span>{{ $t('total') }}</span>
                    <span class="dotted-span"></span>
                    <i-money
                      mode="text"
                      :value="total()"
                      class="main--text pl-1"
                    />
                  </p>
                </div>
              </v-col>
            </v-row>
          </v-card-actions>
        </form>
      </ValidationObserver>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import { VueEditor } from 'vue2-editor'
import ChangePrice from './changePrice.vue'
import DetailsByOrder from './detailsByOrder.vue'
import GetBodyEmail from '../email/getBodyEmail.vue'
import OrderMessages from '../chat/order-messages.vue'
import Repository from './repository.vue'
import SetSuborderState from './SetSuborderState.vue'
import TypeDate from './date.vue'
import ShowProductPrice from '../showProductPrice/list.vue'

export default {
  components: {
    VueEditor,
    ChangePrice,
    DetailsByOrder,
    GetBodyEmail,
    OrderMessages,
    Repository,
    SetSuborderState,
    TypeDate,
    ShowProductPrice
  },
  props: {
    order: {
      type: [Number, String]
    },
    statusOrder: {
      type: String
    },
    customer: {
      type: [Object, String]
    },
    customerTax: {
      default: false,
      type: Boolean
    },
    orderName: {
      type: [String]
    },
    orderImage: {
      type: [File, String]
    }
  },
  data() {
    return {
      divDescription: false,
      divAditionalSide: false,
      divRepository: false,
      divNotes: false,
      divLogs: false,
      divDates: false,
      reload: false,
      load: false,
      loadingIMG: false,
      imageUrl: null,
      imageUrl0: null,
      oldStatus: null,
      oldStatusName: null,
      originalQuantity: null,
      panel: [],
      rewriteprice: 0,
      input: 0,
      discount: 0,
      detailPrices: [],
      creatingDetail: 1,
      projectName: this.orderName,
      taxes: [],
      sale: true,
      hasChatMessages: false,
      subOrder: {
        pk: '',
        name: '',
        order: '',
        status: null,
        product: null,
        dimensions: {},
        price: 0,
        description: '',
        additional_side: '',
        quantity: 1,
        rounded: false,
        subtotal: 0,
        total: 0,
        tax: 0,
        level: 0,
        quoteSelect: '',
        own_prod: '',
        orderStatus: '',
        orderMain: '',
        measure: null,
        template: null,
        customerName: '',
        clientEmail: '',
        clientNotification: '',
        thumbnail: null,
        prodPrice: 0,
        price_type: '',
        chat_id: 0,
        productTax: false,
        clientTax: false
      },
      product: null,
      priceSuggest: null,
      showCost: false,
      dialog: false,
      step: 1,
      loading: false,
      logs: [],
      menu: false,
      menu1: false,
      menu2: false,
      measures: [],
      measure: null,
      stages: [],
      stage: null,
      details: ['preproduction', 'production', 'postproduction', 'extra'],
      matrix: [],
      customToolbar: [
        [{ header: [] }],
        [
          'bold',
          'italic',
          'underline',
          'strike',
          'blockquote',
          'code',
          'code-block'
        ],
        [
          { align: '' },
          { align: 'center' },
          { align: 'right' },
          { align: 'justify' }
        ],
        [{ list: 'ordered' }, { list: 'bullet' }, { list: 'check' }],
        [{ script: 'sub' }, { script: 'super' }],
        [{ indent: '-1' }, { indent: '+1' }],
        [{ color: [] }, { background: [] }]
      ],
      answerList: {
        0: 'suborder_action.created',
        1: 'suborder_action.updated',
        2: 'suborder_action.deleted',
        3: 'suborder_action.access',
        4: 'action'
      },
      // Variable para enviar la señal de actualizar sale/index.
      componentKey: 0,
      isNewOrder: false
    }
  },
  methods: {
    ...mapActions({
      /**
       * Muestra una confirmación de acción en pantalla.
       * Usado para alertar sobre stock insuficiente antes de vender.
       */
      showConfirmation: 'confirmation/confirmationValue'
    }),
    /**
     * Abrir la pesataña del chat de la sub-orden cuando el click viene de una
     * notificación del chat.
     *
     * @author Ing. Argenis Osorio (argenisosorio10 at gmail)
     */
    clickChatButton(id) {
      this.divNotes = false

      // Notas / Chat
      if (id == 4) {
        this.divNotes = true
        this.scrollToBottom()
        this.$nextTick(() => {
          // Espera a que `divNotes` se haga visible.
          setTimeout(() => {
            this.scrollToBottom()
          }, 2000)
        })
        return
      }
    },
    /**
     * Método que muestra u oculta divs dependiendo del botón que se presione
     *
     * @author Angelo Osorio <danielking.321 at gmail.com>
     */
    activate(d) {
      this.divDescription = false
      this.divAditionalSide = false
      this.divRepository = false
      this.divNotes = false
      this.divLogs = false
      this.divDates = false

      // Descripción
      if (d == 1) {
        this.divDescription = true
        return
      }

      // Información adicional
      if (d == 2) {
        this.divAditionalSide = true
        return
      }

      // Repositorio de imágenes
      if (d == 3) {
        this.divRepository = true
        return
      }

      // Notas / Chat
      if (d == 4) {
        this.divNotes = true
        this.$nextTick(() => {
          // Espera a que `divNotes` se haga visible.
          this.scrollToBottom()
        })
        return
      }

      // Logs
      if (d == 5) {
        this.divLogs = true
        this.getLogs()
        return
      }

      // Fechas
      if (d == 6) {
        this.divDates = true
        return
      }
    },
    /**
     * Al hacer click en el botón que muestra el chat se hace scroll hasta el
     * final del modal dialog y también del contenedor del chat.
     *
     * @author Ing. Argenis Osorio (argenisosorio10 at gmail)
     */
    scrollToBottom() {
      const target = this.$refs.scrollTarget // Referencia al contenedor desplazable
      const orderMessagesComponent = this.$refs.orderMessagesComponent // Contenedor del chat

      if (target) {
        target.scrollIntoView({
          top: target.scrollHeight, // Desplazar hasta el final
          behavior: 'smooth' // Desplazamiento suave
        })
      }

      // Esperar hasta que el DOM se haya actualizado.
      this.$nextTick(() => {
        // Ejecutar la lógica la primera vez
        setTimeout(() => {
          if (orderMessagesComponent) {
            // Referencia del componente hijo
            const chatContainer = orderMessagesComponent.$refs.chatContainer
            if (chatContainer) {
              chatContainer.scrollTop = chatContainer.scrollHeight
            }
          }
        }, 500)

        setTimeout(() => {
          if (orderMessagesComponent) {
            // Referencia del componente hijo
            const chatContainer = orderMessagesComponent.$refs.chatContainer
            if (chatContainer) {
              chatContainer.scrollTop = chatContainer.scrollHeight
            }
          }
        }, 1000) // Ejecutar luego de 1 segundo

        setTimeout(() => {
          if (orderMessagesComponent) {
            // Referencia del componente hijo
            const chatContainer = orderMessagesComponent.$refs.chatContainer
            if (chatContainer) {
              chatContainer.scrollTop = chatContainer.scrollHeight
            }
          }
        }, 1800) // Ejecutar luego de 1,8 segundo

        setTimeout(() => {
          if (orderMessagesComponent) {
            // Referencia del componente hijo
            const chatContainer = orderMessagesComponent.$refs.chatContainer
            if (chatContainer) {
              chatContainer.scrollTop = chatContainer.scrollHeight
            }
          }
        }, 2500) // Ejecutar luego de 2,5 segundos
      })
    },
    cloneNameProject() {
      this.subOrder.name = this.projectName
    },
    /**
     * Método que consulta los logs del API y los convierte en información
     * útil para el usuario
     *
     * @author Angelo Osorio <danielking.321 at gmail.com>
     */
    async getLogs() {
      if (this.subOrder.pk) {
        try {
          let responseDecoded = []
          let response = await this.$api.suborder.logs.show({
            pk: this.subOrder.pk
          })

          if (response.data && response.data.length > 0) {
            response.data.forEach((value) => {
              let name = `${value.actor.first_name} ${value.actor.last_name}`
              let formatedDate = this.dateFormat(value.timestamp.split('T')[0])
              let formatedTime = new Date(value.timestamp).toTimeString()

              responseDecoded.push({
                action: value.action,
                date: formatedDate,
                time: formatedTime,
                changes: value.changes,
                fullname: name
              })
            })
          }

          this.logs = responseDecoded
        } catch (err) {
          console.error(err)
        }
      }
    },
    /**
     * Formatea una cadena de estado reemplazando espacios y guiones por guiones
     * bajos.
     *
     * @param {string} status La cadena de estado que se desea formatear.
     *                        Debe ser una cadena que pueda contener espacios o
     *                        guiones.
     *
     * @returns {string}  La cadena formateada, con espacios y guiones
     *                    reemplazados por guiones bajos.
     *
     * @author Ing. Argenis Osorio <argenisosorio10@gmail.com>
     */
    formatStatus(status) {
      if (!status) return ''
      // Reemplazar espacios y guiones con un solo guión bajo
      let formatted = status.replace(/[\s-]+/g, '_')
      // Eliminar guiones bajos dobles
      formatted = formatted.replace(/_{2,}/g, '_')
      return formatted.toLowerCase()
    },
    /**
     * Método para consultar los nombres de los subestados
     * con su correspondiente estado, llevando el formato
     * Nombre estado - nombre subestado
     *
     * @param {Object} item
     * @returns {String}
     *
     * @author Miguel E. Villamizar R. <mevr02 at gmail.com>
     * @author Rosana Mendez <rosanamendez5 at gmail.com>
     * @author Ing. Argenis Osorio <argenisosorio10@gmail.com>
     */
    getNameStatus(item) {
      if (item.dad === undefined || item.dad === null) {
        // Formatear y traducir el nombre simple
        return this.$t(this.formatStatus(item.name))
      } else {
        // Formatear y traducir tanto el nombre del padre como el del hijo
        const dadName = this.$tc(this.formatStatus(item.dad.name), 1)
        const childName = this.$t(this.formatStatus(item.name))
        return `${dadName} - ${childName}`
      }
    },
    /**
     * Método para consultar los subEstados de subOrden, según su estado
     * en la plantilla de proceso de producción asociada al producto
     *
     * @author Miguel E. Villamizar R. <mevr02 at gmail.com>
     * @author Rosana Mendez <rosanamendez5 at gmail.com>
     */
    async getOrderStatus() {
      let response = await this.$api.sale.status.list({
        opt: {
          params: {
            template: this.subOrder.template
          }
        }
      })
      let sta = []
      for (var value in response.data) {
        if (response.data[value].substatusVals.length > 0) {
          sta = sta.concat(response.data[value].substatusVals)
        } else {
          sta.push(response.data[value])
        }
      }
      let root_filter = sta.filter(
        (element) => element.pk === this.subOrder.status
      )
      if (root_filter.length > 0) {
        const {
          dad: { name },
          root
        } = root_filter[0]
        if (name !== 'preprocess') {
          this.stages = sta.filter((element) => element.root === root)
        }
      }
    },
    /**
     * Método para consultar el producto de la subOrden
     *
     * @author Rosana Mendez <rosanamendez5 at gmail.com>
     */
    async getProduct() {
      const { data } = await this.$api.product.show({
        pk: this.subOrder.product
      })
      this.product = data
    },
    /**
     * Método para consultar las unidades de medida si el tipo de precio
     * del producto es fórmula
     *
     * @author Miguel E. Villamizar R. <mevr02 at gmail.com>
     */
    async getProductSold() {
      const response = await this.$api.product.measure.show({
        pk: this.subOrder.product,
        opt: {
          params: {
            product: true
          }
        }
      })
      this.measures = response.data
      if (this.subOrder.measure === null && this.measures.length > 0) {
        let defaultMel = this.measures.find((m) => m.default === true)
        if (defaultMel === undefined) {
          defaultMel = this.measures[0]
        }
        this.subOrder.measure = defaultMel.pk
        this.measure = defaultMel
      } else if (this.subOrder.measure !== null && this.measures.length > 0) {
        let defaultMel = this.measures.find(
          (m) => m.pk === this.subOrder.measure
        )
        this.measure = defaultMel !== undefined ? defaultMel : null
      }
    },
    /**
     * Método para consultar la tasa aplicada a la compañia
     *
     * @author Miguel E. Villamizar R. <mevr02 at gmail.com>
     */
    async getTaxList() {
      let response = await this.$api.tax.list({
        opt: {
          params: {
            company: this.company.pk
          }
        }
      })
      this.taxes = response.data
    },
    async open(item) {
      this.load = false
      this.priceSuggest = item.priceSuggest || 0
      this.step = 1
      this.showCost = false
      this.menu = false
      this.menu1 = false
      this.menu2 = false
      this.creatingDetail = 1
      this.projectName = this.orderName
      this.dialog = true
      let prod = {}
      if (typeof item !== 'object') {
        this.loading = true
        try {
          let { data } = await this.$api.sale.suborder.show({
            pk: item
          })
          prod = data
          if (prod.prodPrice === 0) {
            let res = await this.$api.product.show({ pk: prod.product })
            prod.prodPrice = res.data.priceSuggest
          }
          this.priceSuggest = prod.prodPrice
          this.projectName ??= prod?.projectName
        } catch (error) {
          console.error('error', error)
          this.dialog = false
        } finally {
          this.loading = false
        }
      }
      this.isNewOrder = typeof item === 'object' && item !== null
      if (prod.dimensions === '') {
        prod.dimensions = {}
      }
      this.subOrder =
        typeof item === 'object'
          ? {
              pk: '',
              name: '',
              code: '',
              order: this.order,
              status: null,
              product: item.pk,
              measure: null,
              price: 0,
              priceString: '',
              dimensions: {},
              quantity: 1,
              subtotal: 0,
              description: '',
              additional_side: '',
              quoteSelect: '',
              rounded: false,
              thumbnail: null,
              tax: 0,
              total: 0,
              own_prod: `${item.internalCode} - ${item.name}`,
              template: item.template_id,
              orderStatus: '',
              orderMain: this.statusOrder,
              costprod: item.cost,
              customerName: this.customer,
              customerEmail: this.clientEmail,
              customerTax: this.customerTax,
              productTax: item.tax,
              prodPrice: item.price == 0 ? item.priceSuggest : item.price,
              price_type: item.price_type,
              level: 0,
              chat_id: item.chat_id
            }
          : prod

      if (this.subOrder?.chat_id && this.subOrder.chat_id > 0) {
        this.getChat(this.subOrder.chat_id)
      }

      this.oldStatus = this.subOrder.status
      this.oldStatusName = this.subOrder.orderStatus
      this.originalQuantity = this.subOrder.quantity
      this.getProduct()
      if (
        ['in_process'].includes(this.subOrder.orderMain) &&
        this.subOrder.template
      )
        this.getOrderStatus()
      this.getProductSold()
      try {
        this.imageUrl = this.subOrder.thumbnail
        this.loadingIMG = false
      } catch (error) {
        this.imageUrl = require('@/assets/default_image.png')
        this.loadingIMG = false
      }
    },
    back() {
      this.step -= 1
    },
    next() {
      this.$refs.form.validate().then((success) => {
        if (success || this.subOrder.name !== '') {
          this.step += 1
        }
      })
    },
    /**
     * Método para autentar o disminuir en 1 la cantidad
     *
     * @author Angelo Osorio <danielking.321 at gmail.com>
     */
    changeQuantity(mode) {
      if (mode === '+1') {
        this.subOrder.quantity = Number(this.subOrder.quantity) + 1
      }
      if (mode === '-1') {
        this.subOrder.quantity = Number(this.subOrder.quantity) - 1
      }
    },
    /**
     * Método para mostrar flecha siguiente
     *
     * @author Angelo Osorio <danielking.321 at gmail.com>
     */
    showNext() {
      return this.subOrder.pk && this.step < 2
    },
    /**
     * Método para guardar o editar una subOrden
     *
     * @param {FormData} form_data Toda la data de la suborden
     *
     * @author Paul Rojas
     * @author Rosana Mendez <rosanamendez5 at gmail.com>
     */
    async save(form_data) {
      this.load = true
      try {
        const response = !this.subOrder.pk
          ? await this.$api.sale.suborder.create({ form: form_data })
          : await this.$api.sale.suborder.edit({
              pk: this.subOrder.pk,
              form: form_data
            })

        if (this.subOrder.pk) {
          this.$emit('prod', response.data)
          this.close()
          this.$toast.success(
            `${this.$tc('suborder', 1)} ${this.$tc('edited', 2)}`
          )
        } else {
          this.subOrder = response.data
          this.originalQuantity = this.subOrder.quantity
          this.$toast.success(
            `${this.$tc('suborder', 1)} ${this.$tc('created', 2)}`
          )
        }

        if (response.data.emailTemplate) {
          this.$store.dispatch(
            'utils/openDialogEmailNotification',
            response.data.emailTemplate
          )
        }

        this.$store.dispatch('utils/createdsuborder', true)
      } catch (error) {
        // Manejo específico de errores de thumbnail
        if (error.response?.data?.thumbnail) {
          // Reintentar sin thumbnail si el error es por formato de archivo
          if (error.response.data.thumbnail.includes('no era un archivo')) {
            this.retryWithoutThumbnail()
            return
          }
        }
      } finally {
        this.load = false
      }
    },
    /**
     * Reintenta el guardado sin el thumbnail
     */
    async retryWithoutThumbnail() {
      let form_data = new FormData()

      for (let key in this.subOrder) {
        if (this.subOrder[key] == null || key === 'thumbnail') {
          continue // Excluir thumbnail completamente
        }

        form_data.append(
          key,
          key !== 'dimensions'
            ? this.subOrder[key]
            : JSON.stringify(this.subOrder[key])
        )
      }

      try {
        const response = this.subOrder.pk
          ? await this.$api.sale.suborder.edit({
              pk: this.subOrder.pk,
              form: form_data
            })
          : await this.$api.sale.suborder.create({
              form: form_data
            })

        if (this.subOrder.pk) {
          this.$emit('prod', response.data)
          this.close()
          this.$toast.success(
            `${this.$tc('suborder', 1)} ${this.$tc('edited', 2)}`
          )
        } else {
          this.subOrder = response.data
          this.originalQuantity = this.subOrder.quantity
          this.$toast.success(
            `${this.$tc('suborder', 1)} ${this.$tc('created', 2)}`
          )
        }

        if (response.data.emailTemplate) {
          this.$store.dispatch(
            'utils/openDialogEmailNotification',
            response.data.emailTemplate
          )
        }
      } catch (retryError) {
        this.$toast.error(this.$t('save_error'))
      } finally {
        this.load = false
      }
    },
    /**
     * Verifica si la subOrden tiene diseñadores o productores asignados.
     * Si no hay usuarios asignados y el estado actual no es "in_wait" o "rejected",
     * cambia el estado de la subOrden a "in_wait" y muestra un mensaje de error.
     *
     * @returns {void}
     *
     * @author Rosana Mendez <rosanamendez5 at gmail.com>
     */
    assignedUsers() {
      // Buscar el estado "in_wait" dentro de los subestados disponibles
      const in_wait = this.stages.find((m) => m.name === 'in_wait')

      // Extraer los estados actuales de la subOrden
      const { leader_status, status } = this.subOrder

      // Verificar si el estado "in_wait" existe y si el estado actual no es
      // "in_wait" ni "rejected"
      if (
        in_wait &&
        leader_status !== undefined &&
        status !== 'in_wait' &&
        status !== 'rejected'
      ) {
        /**
         * @function assignStatus
         *
         * Función interna para verificar si un rol (diseñador o productor)
         * tiene usuarios asignados. Si no los tiene, cambia el estado de la
         * subOrden a "in_wait" y muestra un mensaje de error.
         *
         * @param {string} role - El rol a verificar (por ejemplo, "designer" o
         * "production").
         * @param {string} message - La clave de traducción para el mensaje de
         * error.
         */
        const assignStatus = (role, message) => {
          // Determinar el estado asociado al rol (por ejemplo, "design" para
          // "designer")
          const roleStatus = role === 'designer' ? 'design' : role

          // Verificar si no hay usuarios asignados para el rol y si el estado
          // padre coincide
          if (
            leader_status[role] === undefined &&
            in_wait.dad.name === roleStatus
          ) {
            // Cambiar el estado de la subOrden a "in_wait"
            this.subOrder.status = in_wait.pk

            // Mostrar un mensaje de error indicando que no hay usuarios
            // asignados
            this.$toast.error(`${this.$tc(message, 1)}`)
          }
        }

        // Verificar si hay diseñadores asignados
        assignStatus('designer', 'assignDesigners')

        // Verificar si hay productores asignados
        assignStatus('production', 'assignProductions')
      }
    },
    /**
     * Método para recolectar la información a guardar de una subOrden,
     * una vez verificado que tenga usuarios asignados y se realice la
     * notificación en caso de cambio de estado
     *
     * @author Miguel E. Villamizar R. <mevr02 at gmail.com>
     * @author Rosana Mendez <rosanamendez5 at gmail.com>
     */
    async submit() {
      this.assignedUsers()
      this.$refs.form.validate().then((success) => {
        if (success || this.step == 2 || this.subOrder.status != '') {
          let form_data = new FormData()
          for (var key in this.subOrder) {
            if (this.subOrder[key] == null) {
              continue
            }
            form_data.append(
              key,
              key !== 'dimensions'
                ? this.subOrder[key]
                : JSON.stringify(this.subOrder[key])
            )
            // Lógica mejorada del thumbnail
            if (
              key == 'thumbnail' &&
              !(this.subOrder.thumbnail instanceof File)
            ) {
              form_data.delete('thumbnail')
            }
          }
          /**
           * Ejecuta el proceso de guardado (creación o edición) de la suborden.
           * Se encapsula para poder reutilizarse como callback en el diálogo de confirmación.
           */
          const executeSave = async () => {
            try {
              this.load = true
              await this.save(form_data)
            } finally {
              this.componentKey += 1
              localStorage.setItem('componentKey', this.componentKey)
            }
          }

          /**
           * Validación de Stock:
           * Verifica si el producto requiere control de inventario (Tipos: BOTH, PURCHASE).
           * Si la cantidad solicitada supera el stock disponible (quantity), muestra un diálogo
           * de confirmación para alertar al usuario, pero le permite continuar si acepta.
           */
          if (
            this.step === 2 &&
            this.product &&
            ['BOTH', 'PURCHASE'].includes(this.product.can_be) &&
            (!this.subOrder.pk ||
              parseFloat(this.subOrder.quantity) >
                parseFloat(this.originalQuantity)) &&
            parseFloat(this.product.quantity) <
              parseFloat(this.subOrder.quantity)
          ) {
            this.showConfirmation({
              show: true,
              title: this.$tc('alert', 1),
              model: '',
              type: 'primary',
              content: this.$t('confirm_sale_stock'),
              alert: this.$tc('suborder', 1) + ' ' + this.$tc('edited', 2),
              confirm: () => executeSave(),
              cancel: () => {
                if (this.isNewOrder && this.subOrder.pk) {
                  this.$api.sale.suborder
                    .remove({ pk: this.subOrder.pk })
                    .then(() => {
                      this.$toast.info(
                        `${this.$tc('suborder', 1)} ${this.$tc('deleted', 2)}`
                      )
                      this.$emit('deleted', this.subOrder.pk)
                      this.$store.dispatch('utils/createdsuborder', true)
                      this.close()
                    })
                } else {
                  this.close()
                }
              }
            })
          } else {
            executeSave()
          }
        }
      })
    },
    close() {
      if (this.$refs.imgAppr !== undefined) {
        this.$refs.imgAppr.clearForm()
      }
      this.dialog = false
      document.oncontextmenu = function () {
        return true
      }
      this.$emit('close')
    },
    /**
     * Método para calcular el precio del item/subitem por la cantidad del
     * producto
     *
     * @param {Number} itemPK
     * @param {Boolean} itemMulti
     *
     * @returns {Boolean}
     *
     * @author Angelo Osorio <danielking.321 at gmail.com>
     */
    itemMultiply(is_multipliable, price, quantity) {
      if (is_multipliable) {
        return price * quantity
      }
      return price
    },
    /**
     * Método para calcular la sumatoria de los items/subitems ocultados
     *
     * @returns {Number} Sumatoria de los items/subitems ocultados
     *
     * @author Angelo Osorio <danielking.321 at gmail.com>
     */
    hiddenDetailsSum() {
      let hiddenItems = this.detailPrices.filter(
        (element) => element.hidden === true
      )

      if (hiddenItems.length) {
        let sum = hiddenItems.reduce((accumulator, item) => {
          return (
            accumulator +
            Number(
              this.itemMultiply(
                item.is_multipliable,
                item.price,
                this.subOrder.quantity
              )
            )
          )
        }, 0)
        return sum
      }

      return 0
    },
    /**
     * Método para calcular la sumatoria de los subtotales de items/subitems
     *
     * @param {Array} priceArray Arreglo de detalles de producción de la suborden
     *
     * @returns {Number} Sumatoria total de los detalles de producción
     *
     * @author Angelo Osorio <danielking.321 at gmail.com>
     */
    detailsSum(priceArray) {
      let sum = priceArray.reduce((accumulator, item) => {
        return (
          accumulator +
          Number(
            this.itemMultiply(
              item.is_multipliable,
              item.price,
              this.subOrder.quantity
            )
          )
        )
      }, 0)
      return parseFloat(sum)
    },
    /**
     * Método para calcular el subtotal de la suborden
     *
     * @returns {Number}
     *
     * @author Angelo Osorio <danielking.321 at gmail.com>
     */
    subtotal() {
      if (this.subOrder.priceString && this.subOrder.price_type === 'formula') {
        this.subOrder.price = parseFloat(
          eval(this.subOrder.priceString).toFixed(2)
        )
      }

      const discount = parseFloat(this.discount) || 0
      const rewrite = parseFloat(this.rewriteprice) || 0
      const price = parseFloat(this.subOrder.price) || 0
      const quantity = parseFloat(this.subOrder.quantity) || 1
      const detailSum = this.detailsSum(this.detailPrices) || 0
      const subtotalValue = discount + rewrite + price * quantity + detailSum

      this.subOrder.subtotal = parseFloat(subtotalValue).toFixed(2)
      return this.subOrder.subtotal
    },
    /**
     * Método para calcular el total de la suborden
     *
     * @returns {Number}  total de la suborden
     *
     * @author Angelo Osorio <danielking.321 at gmail.com>
     */
    total() {
      const subtotal = parseFloat(this.subOrder.subtotal)
      this.subOrder.tax = this.calculateTaxes(
        subtotal,
        this.subOrder.productTax,
        this.subOrder.clientTax
      )
      const totalValue = parseFloat(subtotal) + parseFloat(this.subOrder.tax)
      this.subOrder.total = parseFloat(totalValue).toFixed(2)
      return this.subOrder.total
    },
    /**
     * Método para calcular los impuestos del producto de la suborden
     *
     * @param {Number} [subtotal=0] Cantidad de subtotal
     * @param {Boolean} [product=false] Define si el producto debe llevar taxes
     * @param {Boolean} [customer=false] Define si el cliente debe llear taxes
     *
     * @returns {Number}
     *
     * @author Angelo Osorio <danielking.321 at gmail.com>
     */
    calculateTaxes(subtotal = 0, product = false, customer = false) {
      if (product && customer && this.taxes.length) {
        const sumTaxes = this.taxes.reduce((total, objeto) => {
          const calculo = (subtotal * objeto.percent) / 100
          return total + calculo
        }, 0)
        return parseFloat(sumTaxes).toFixed(2)
      }
      return 0
    },
    /**
     * Método para consultar los mensajes no leídos del chat de la subOrden
     *
     * @author Rodrigo Boet <rudmanmrrod at gmail.com>
     * @author Angelo Osorio <danielking.321 at gmail.com>
     */
    async getChat(chatPK) {
      await this.$api.chat.product
        .unreadMessages({ pk: chatPK })
        .then((response) => {
          if (response.data.messages_count > 0) {
            this.hasChatMessages = true
          } else {
            this.hasChatMessages = false
          }
        })
        .catch((error) => {
          console.error(error)
        })
    },
    /**
     * Evento para confirmar la asignación o no de un diseñador
     */
    confirmDesigner() {
      this.$emit('confirmDesigner')
    }
  },
  watch: {
    'subOrder.measure': {
      handler() {
        if (this.subOrder.measure !== null) {
          this.measure = this.measures.find(
            (m) => m.pk === this.subOrder.measure
          )
          if (
            typeof this.measure === 'object' &&
            this.measure.rounded === false
          ) {
            this.subOrder.rounded = false
          }
        }
      }
    },
    'subOrder.status': {
      handler() {
        if (this.subOrder.status && this.subOrder.template) {
          this.stage = this.stages.find((m) => m.pk === this.subOrder.status)
          this.subOrder.orderStatus =
            this.stage === undefined ? '' : this.stage.name
        }
      }
    }
  },
  computed: {
    ...mapGetters({
      company: 'company/getCompanyData',
      getPermissions: 'session/getPermissions',
      isAdmin: 'session/isAdmin',
      me: 'session/me',
      createdsubOrder: 'utils/createdsubOrder'
    }),
    defaultmeasure() {
      let defaultMel = this.measures.find((m) => m.default === true)
      if (defaultMel === undefined) {
        defaultMel = this.measures[0]
      }
      defaultMel =
        defaultMel === undefined
          ? ''
          : defaultMel.name.split('(')[1].replace(')', '')
      return defaultMel
    },
    /**
     * Determina el nombre del cliente
     *
     * @returns {string} Nombre del cliente
     *
     * @author Angelo Osorio <danielking.321 at gmail.com>
     */
    defineClientInfo() {
      if (this.subOrder.clientName) {
        return this.subOrder.clientName
      }
      if (this.subOrder.clientFullname) {
        return this.subOrder.clientFullname
      }
      return this.customer
    },
    /**
     * Determina si el estado de la orden pertenece al grupo de estados que se
     * le especifica.
     *
     * @returns {Object} Fases de la orden
     *
     * @author Angelo Osorio <danielking.321 at gmail.com>
     */
    checkPhase() {
      const order = this.subOrder.orderMain
      return {
        isInFinalPhase: order === 'in_process' || order === 'finished',
        isReadOnly: !(order === 'draft' || order === 'quote')
      }
    },
    /**
     * Determina si el usuario tiene los permisos necesarios según la indicación
     *
     * @returns {Object} Objeto con los permisos del usuario.
     *
     * @author Angelo Osorio <danielking.321 at gmail.com>
     */
    checkPermissions() {
      return {
        isElevatedRole:
          this.getPermissions([`users.change_profile`]) &&
          this.getPermissions([`auth.change_user`]),
        isDesigner:
          this.getPermissions([`sales.change_assigneduser`]) &&
          this.getPermissions([`sales.view_assigneduser`]),
        isProducer:
          this.getPermissions([`sales.view_assigneddepartment`]) &&
          this.getPermissions([`sales.change_assigneddepartment`]),
        details: this.getPermissions([`product.view_productiondetails`]),
        customer: this.getPermissions([`customer.view_customer`]),
        imageRepository:
          this.getPermissions([`sales.view_imagerepository`]) &&
          this.getPermissions([`sales.add_imagerepository`]) &&
          this.getPermissions([`sales.change_imagerepository`]) &&
          this.getPermissions([`sales.delete_imagerepository`]) &&
          this.getPermissions([`sales.view_repositorylabels`]) &&
          this.getPermissions([`sales.add_repositorylabels`]) &&
          this.getPermissions([`sales.change_repositorylabels`]) &&
          this.getPermissions([`sales.delete_repositorylabels`]),
        typedate: this.getPermissions([`sales.view_typedate`]),
        soldby: this.getPermissions([`base_config.view_soldby`]),
        soldbyEdit: this.getPermissions([`base_config.change_soldby`])
      }
    },
    /**
     * Computado para determinar el estado de la orden.
     * inDesign: Es diseñador y la orden está en una fase de diseño
     * underReview: Es admin y la orden está en fase de revisión
     *
     * @returns {Object} Objeto con los permisos del usuario.
     *
     * @author Angelo Osorio <danielking.321 at gmail.com>
     */
    canChangeStatus() {
      return {
        inDesign:
          this.stages.some((stage) => stage.dad.name === 'design') &&
          this.checkPermissions.isDesigner,
        underReview:
          this.stages.some(
            (stage) => stage.dad.name === 'design_under_review'
          ) && this.checkPermissions.isElevatedRole
      }
    }
  },
  mounted() {
    this.getTaxList()
    window.addEventListener(
      'keydown',
      function (e) {
        if (this.dialog && e.keyCode === 113) {
          e.preventDefault()
          this.showCost = !this.showCost
        }
      }.bind(this)
    )
    /**
     * Metodo para actualizar la suborden abierta en el dialog
     * listerner global que escucha el evento 'componentKeyUpdated'
     * y actualiza la suborden si el componente dialog está abierto
     */
    this._onComponentKeyUpdated = async () => {
      try {
        if (this.dialog && this.subOrder && this.subOrder.pk) {
          // Refresca la suborden abierta desde la API
          try {
            const resp = await this.$api.sale.suborder.show({
              pk: this.subOrder.pk
            })
            const data = resp.data || {}
            // Asigna de forma reactiva todas las claves recibidas
            Object.keys(data).forEach((k) => {
              this.$set(this.subOrder, k, data[k])
            })
            // Actualiza recursos dependientes
            try {
              this.imageUrl = this.subOrder.thumbnail
            } catch (e) {
              this.imageUrl = require('@/assets/default_image.png')
            }
            this.getProduct()
            this.getProductSold()
          } catch (err) {
            // Error al refrescar suborden
          }
        }
      } catch (e) {
        // Error en el handler de componentKey
      }
    }
    window.addEventListener('componentKeyUpdated', this._onComponentKeyUpdated)
  },
  beforeDestroy() {
    // remove listener global si fue registrado
    try {
      if (this._onComponentKeyUpdated) {
        window.removeEventListener(
          'componentKeyUpdated',
          this._onComponentKeyUpdated
        )
      }
    } catch (e) {
      // Error al remover listener
    }
  }
}
</script>
<style lang="sass">
.dialog-product
  &--modal
    background-color: var(--v-auxbg-base)
    &.v-dialog:not(.v-dialog--fullscreen)
      // Modal contenedora de la suborden
      align-self: stretch
  &--modal-second-step
    // Paso 2 de la modal de la suborden
    overflow: auto
    max-height: calc(100dvh - 540px)
    @media (width >= 960px)
      max-height: calc(100dvh - 378px)
  &--fixed-actions
    // Contenedor de la sección fija de cálculo de precios
    @media (width >= 960px)
      bottom: 0
      position: fixed
      right: 0
      width: 100%
  &--fixed-details
    // Sección fija (izquierda) de cálculo de precios
    background-color: var(--v-primary-base)
    color: var(--white)
    margin: 0
    height: 157px
    overflow-y: auto
    box-shadow: 0 2px 4px -1px rgba(0, 0, 0, .3), 0 4px 5px 0 rgba(0, 0, 0, .3), 0 1px 10px 0 rgba(0, 0, 0, .3)
    @media (width >= 960px)
      border-radius: 20px 0px 0px 20px
  &--fixed-total
    // Sección fija (derecha) de cálculo de precios
    background-color: var(--v-auxbg-base)
    border-radius: 20px
    border: 1px solid var(--v-primary-base)
    padding: 10px 20px
    height: 157px
    overflow-y: auto
    box-shadow: 0 2px 4px -1px rgba(0, 0, 0, .3), 0 4px 5px 0 rgba(0, 0, 0, .3), 0 1px 10px 0 rgba(0, 0, 0, .3)
    @media (width >= 960px)
      border-radius: 0px 20px 20px 0px
  &--fixed-left
    padding-top: 0
    @media (width >= 960px)
      padding-right: 0
  &--fixed-right
    @media (width >= 960px)
      padding-top: 0
      padding-left: 0
.container-buttons
  display: flex
  flex-wrap: wrap
  flex-direction: row
  gap: 15px
  margin-bottom: 15px

.text-sumatory
  font-size: 18px
  display: flex
  justify-content: space-between
  .dotted-span
    flex: 1 1 auto
    border-bottom: 1px dotted var(--v-auxtext-base)
    margin: 0 5px 7px 5px
  .main--text
    font-weight: bold

.details-selected-sumatory
  display: flex
  justify-content: space-between
  .dotted-span
    flex: 1 1 auto
    border-bottom: 1px dotted #fff
    margin: 0 5px 7px 5px
  .main--text
    font-weight: bold

.descriptiveMoney
  font-weight: bold
  font-size: larger
  @media (width >= 960px)
    font-size: medium

.v-stepper__content
  padding: 1em !important

.v-stepper__wrapper
  padding: 2em !important

.clone-image-button
  position: absolute
  top: 0
  right: 0
  border: 2px solid var(--secundary)
  top: calc(50% + 32px)
  margin-right: 8px
  border-radius: 50%
  & > button
    width: 40px
    height: 40px

.position-relative #image.image-repo > button
  top: 30%
  &:nth-child(1)
    top: calc(30% - 5px)

.theme--dark
  .dialog-product--modal
    .ql-editor.ql-blank::before
      // Color del placeholder de descripción e información adicional
      color: rgb(255 255 255 / 60%)
</style>
